import { User } from "../@core/data/users";

export default class QnA {
  id?: string;
  courseId?: string;
  sectionId?: string;
  lectureId?: string;
  quizId?: string;
  refTitle?: string;

  title?: string;
  description?: string;
  sourceType?: string; //video/images/document
  content?: string; //document
  videoUrl?: string; //video
  imagesUrl?: string[]; //images

  tags?: string[];
  privacy?: boolean;
  status?: number;

  noViewer?: number;
  noLiked?: number;
  noReply?: number;

  //Moderator
  isReviewed?: boolean;
  isApproved?: boolean;
  approvedOn?: Date;
  approvedBy?: string;
  approvedAuthor?: User;

  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
}

export class QnAReply {
  id?: string;
  qnaId?: string;
  qnaTitle?: string;
  qnaDescription?: string;

  content?: string;
  privacy?: boolean;

  toReplyId?: string;
  toUid?: string;
  toAuthor?: User;

  noLiked?: number;

  //render/editing
  editing?: boolean;
  loading?: boolean;

  //Moderator
  isReviewed?: boolean;
  isApproved?: boolean;
  approvedOn?: Date;
  approvedBy?: string;
  approvedAuthor?: User;

  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
}
